// https://github.com/ReactTraining/react-router/blob/master/FAQ.md#how-do-i-access-the-history-object-outside-of-components
import { createBrowserHistory } from "history";
import { get } from "data/constants";

export default createBrowserHistory({
    basename: get(window.CONFIG, ["host", "basename"], ""),
});
